import PropTypes from 'prop-types';
import { createContext } from 'react';
// hooks
import { useMemoryState } from '../utils/memoryState';

// ----------------------------------------------------------------------

const defaultFilter = {
    f5:0,
    rarity: [false, false, false, false, false, false],
    element: [false, false, false, false, false],
    skill: [false, false, false, false, false, false, false],
    page: 1,
    count: 18,
    sort: 0,
    sort_type: 3,
    totalRow: 0,
    forSale: 1,
}

const initialState = {
    ...defaultFilter,
    onf5: () => { },
    onChangeRarity: () => { },
    onChangeElement: () => { },
    onChangeSkill: () => { },
    onChangePage: () => { },
    onChangeCount: () => { },
    onChangeSort: () => { },
    onChangeSortType: () => { },
    onChangeSale: () => { },
    onChangeTotalRow: () => { },
    onReset: () => { }
};

const FilterBombContext = createContext(initialState);

// ----------------------------------------------------------------------

FilterBombProvider.propTypes = {
  children: PropTypes.node,
};

function FilterBombProvider({ children }) {

    const [filterSetting, setFilterSetting] = useMemoryState('filterBombSetting', {
        f5:initialState.f5,
        rarity: initialState.rarity,
        element: initialState.element,
        skill: initialState.skill,
        page: initialState.page,
        count: initialState.count,
        sort: initialState.sort,
        sort_type: initialState.sort_type,
        totalRow: initialState.totalRow,
        forSale: initialState.forSale,
    });

    const onReset = () => {
        setFilterSetting({
            ...filterSetting,
            f5: initialState.f5,
            rarity: initialState.rarity,
            element: initialState.element,
            skill: initialState.skill,
            // page: initialState.page,
            count: initialState.count,
            sort: initialState.sort,
            // sort_type: initialState.sort_type,
            forSale: initialState.forSale,
        });
    };

    const onf5 = (state) => {
        setFilterSetting({
            ...filterSetting,
            f5:state,
        });
    };

    const onChangeRarity = (state) => {
        setFilterSetting({
            ...filterSetting,
            rarity: state,
            page:1
        });
    };

    const onChangeElement = (state) => {
        setFilterSetting({
            ...filterSetting,
            element: state,
            page:1
        });
    };

    const onChangeSkill = (state) => {
        setFilterSetting({
            ...filterSetting,
            skill: state,
            page:1
        });
    };

    const onChangeCount = (state) => {
        setFilterSetting({
            ...filterSetting,
            count: state,
        });
    };
    
    const onChangePage = (state) => {
        setFilterSetting({
            ...filterSetting,
            page: state,
        });
    }
        
    const onChangeSort = (state) => {
        setFilterSetting({
            ...filterSetting,
            sort: state,
            
        });
    };
    
    const onChangeSortType = (state) => {
        setFilterSetting({
            ...filterSetting,
            sort_type: state,
            
        });
    };

    const onChangeSale = (state) => {
        setFilterSetting({
            ...filterSetting,
            forSale: state,
            page:1
        });
    };

    const onChangeTotalRow = (state) => {
        setFilterSetting({
            ...filterSetting,
            totalRow: state,
        });
    };

    return (
        <FilterBombContext.Provider
            value={{
                ...filterSetting,
                onf5,
                onChangeRarity,
                onChangeElement,
                onChangeSkill,
                onChangePage,
                onChangeCount,
                onChangeSort,
                onChangeSortType,
                onChangeSale,
                onChangeTotalRow,
                onReset
            }}
        >
            {children}
        </FilterBombContext.Provider>
    );
}

export { FilterBombProvider, FilterBombContext }
